import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	provinces: [],
	user: {
		permissions: [],
	},
};

export const appSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		updateCategories: (state, action) => {
			state.categories = action.payload;
		},
		updateConfigs: (state, action) => {
			state.configs = action.payload;
		},
		updateProvinces: (state, action) => {
			state.provinces = action.payload;
		},
		updateSettings: (state, action) => {
			state.settings = action.payload;
		},
		updateUser: (state, action) => {
			state.user = action.payload;
		},
	},
});

export const {
	updateCategories,
	updateConfigs,
	updateProvinces,
	updateSettings,
	updateUser,
} = appSlice.actions;

export default appSlice.reducer;
